import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ComponentService } from 'src/app/service/component.service';
import { OrderDetailsService } from '../../../../../service/myaccount/order-details.service';

@Component({
  selector: 'app-order-details-payment-return',
  templateUrl: './order-details-payment-return.component.html',
  styleUrls: ['./order-details-payment-return.component.scss'],
  standalone: false,
})
export class OrderDetailsPaymentReturnComponent implements OnInit, OnDestroy {
  orders$: Observable<any>;
  orderId: string;

  orderDetailsSubscription$: Subscription;
  // custom Order type
  order: any;

  constructor(protected orderDetailsService: OrderDetailsService, private componentService: ComponentService) {}

  ngOnInit() {
    this.orderDetailsSubscription$ = this.componentService.orderDetails$.subscribe((orderDetails) => {
      this.order = orderDetails;
    });
  }

  ngOnDestroy() {
    if (this.orderDetailsSubscription$) {
      this.orderDetailsSubscription$.unsubscribe();
    }
  }
}
